import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=33aaadf1"
import script from "./OrganizationPage.vue?vue&type=script&lang=ts"
export * from "./OrganizationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports